import { isNumber, last, split } from 'lodash';
import numeral from 'numeral';
import { ACCEPT_TYPE_IMAGE, EmptyText } from 'src/utils/constants/config';
import { AuthRouteKeys } from 'src/utils/constants/routes';

export const checkIsValidType = (file: File) => {
  return ACCEPT_TYPE_IMAGE.includes(file.type);
};

export const convertBytesToSize = (bytes: number, toType: 'kb' | 'mb') => {
  let base = 1024;
  // if (toType === "kb") base = base
  if (toType === 'mb') base = Math.pow(base, 2);
  return (bytes / base).toFixed(2);
};

export const getNormalizedRoute = (pathname: string): AuthRouteKeys => {
  return pathname.replace(/[a-f0-9]{32}/g, ':id?') as AuthRouteKeys;
};

export const convertToYoutubeEmbedLink = (url = '') => {
  if (!url) return '';
  const id = last(split(url, '='));
  return 'https://www.youtube.com/embed/' + id;
};
export const downloadFile = (response: Blob, name: string, type: 'csv' | 'xlsx' | 'pdf') => {
  const csvURL = URL.createObjectURL(response);
  const link = document.createElement('a');
  link.href = csvURL;
  link.download = `${name}.${type}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const formatValueUSD = (value: any) => {
  if (!value || !isNumber(value)) return EmptyText;
  if (Math.abs(value) < 1000) {
    return value.toFixed(2);
  }
  return numeral(value).format('0,0');
};

export const convertSvgToCanvas = async (img: HTMLImageElement): Promise<void> => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      resolve();
      return;
    }
    const newImg = new Image();
    newImg.crossOrigin = 'anonymous';
    newImg.onload = () => {
      canvas.width = newImg.width || 20;
      canvas.height = newImg.height || (newImg.width * 3900) / 7410;
      ctx.drawImage(newImg, 0, 0, canvas.width, canvas.height);
      img.src = canvas.toDataURL('image/png');
      resolve();
    };
    newImg.onerror = () => {
      console.warn('Failed to load SVG');
      resolve();
    };
    newImg.src = img.src;
  });
};

export const getPageSizeBaseOnTotalRecords = (totalRecords: number): number => {
  if (totalRecords <= 1000) return 100;
  if (totalRecords <= 5000) return 500;
  return 1000;
}